import { getFolderFilesService } from "src/services/AssetService";
import { tryToJsonParse } from "src/utils";

export class DocumentOrImageV2 {
    id!: number;
    type: string = '';
    input: string = '';
    output: string = '';
    status: string = '';
    user: string | number = '';
    created_at: string = '';
	updated_at: string = '';

    constructor(doc: Partial<DocumentOrImageV2>) {
        Object.assign(this, doc);
    }

    public getId() {
        return this.id;
    }

    public async getImages() {
        if(this.input) {
            const data = tryToJsonParse(this.input);
            if(data) {
                if(data.folder) {
                    const data2 = await getFolderFilesService(data.folder);
                    if(data2.success) {
                        return {
                            items: data2.items.map(item => item.name),
                            folderName: data2.folder.name
                        }
                    }
                }
            }
        }
        return null;
    }

    public getQuestion() {
        if(this.input) {
            const data = tryToJsonParse(this.input);
            if(data) {
                    return data.message;
            }
        }

        return null;
    }

    public getSource() {
        if(this.input) {
            const data = tryToJsonParse(this.input);
            if(data) {
                    return data.folder;
            }
        }

        return null;
    }

    public getAgent() {
        if(this.input) {
            const data = tryToJsonParse(this.input);
            if(data) {
                    return data.agent.replace('agent_', '');
            }
        }

        return null;
    }

    public getResults(type = 'normal') {
        if(this.output) {
            const data = tryToJsonParse(this.output);
            if(data) {
                if(type === 'string') {
                    return data.message;
                }
                return tryToJsonParse(data.message);
            }
        }

        return null;
    }
}

export interface DocumentV2Data {
    agent_id: string | number,
    user: string | number,
    question: string,
    test: boolean,
    key_filter: string,
    history: boolean,
    session_id: string,
    meta_data: {
        folder: string
    }
}

export type ImageV2Data = Omit<DocumentV2Data, 'meta_data'> & {
    meta_data: {
        base64_files: {
            name: string,
            value: string
        }[]
    }
};

export type DocumentWithoutMetadata = Omit<DocumentV2Data, 'meta_data'>;

export interface SourcesDocumentV2 {
    metadata: {
        source?: string,
        page?: number
    };
    page_content: string;
}

export interface DocumentV2Response {
    message: string;
    sources: SourcesDocumentV2[];
}
